export const FETCH_FILTERS = 'FETCH_FILTERS';
export const CREATE_FILTER = 'CREATE_FILTER';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const DELETE_FILTER = 'DELETE_FILTER';
